module.exports = __webpack_public_path__ + "img/bg_Introduction.3bc6c448.png";